import React from 'react';
import { makeStyles } from '@material-ui/core';
import { BsGenderIcon, BsLinkIcon } from '../../../../../../components/Icon';
import { classNames } from '../../../../../../utils';

const getCssValue = (bedHead = 'top', topVal, bottomVal) => {
  switch (bedHead) {
    case 'top':
      return topVal;
    case 'bottom':
      return bottomVal;
    default:
      return topVal;
  }
};

const useStyles = makeStyles((theme) => ({
  root: ({ rootBg, rootBorder, bedHead }) => ({
    width: '4.2rem',
    height: '4.2rem',
    borderRadius: '4px',
    background: rootBg,
    display: 'flex',
    flexDirection: getCssValue(bedHead, 'column', 'column-reverse'),
    alignItems: 'center',
    border: rootBorder,
    position: 'relative',
    flexShrink: 0,
    marginLeft: '0.4rem',
  }),
  box1: ({ boxBorder, boxOpacity, bedHead }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    height: '1.071rem',
    width: '100%',
    borderStyle: 'solid',
    borderColor: boxBorder === 'unset' ? 'transparent' : boxBorder,
    borderWidth: getCssValue(bedHead, '0 0 0.11rem 0', '0.11rem 0 0 0'),
    opacity: boxOpacity,
  }),
  box2: ({ boxBorder, boxOpacity, bedHead }) => ({
    width: '1.571rem',
    height: '0.785rem',
    borderRadius: '0.187rem',
    borderStyle: 'solid',
    borderColor: boxBorder === 'unset' ? 'transparent' : boxBorder,
    borderWidth: getCssValue(bedHead, '0.11rem 0.11rem 0 0.11rem', '0 0.11rem 0.11rem 0.11rem'),
    display: 'flex',
    margin: getCssValue(bedHead, '-0.79rem 0 0 0', '0 0 -0.78rem 0'),
    opacity: boxOpacity,
    position: 'relative',
    justifyContent: 'center',
    alignItems: getCssValue(bedHead, 'flex-end', 'flex-start'),
  }),
  bedNo: () => ({
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  }),
  bedNoFont: ({ bedNoFont }) => ({
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.43rem',
    fontWeight: 'bold',
    color: bedNoFont,
    lineHeight: '1.35rem',
  }),
  ward: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.7rem',
    lineHeight: '0.8rem',
  },
  linkIcon: ({ bedHead }) => ({
    fontSize: '1.3rem',
    position: 'absolute',
    right: getCssValue(bedHead, '0', 'unset'),
    left: getCssValue(bedHead, 'unset', '0'),
    bottom: getCssValue(bedHead, '0', 'unset'),
    top: getCssValue(bedHead, 'unset', '0'),
    transform: getCssValue(bedHead, 'translate(35%, 35%)', 'translate(-35%, -35%)'),
    color: '#538fff',
  }),
  genderIcon: ({ bedNoFont, bedHead }) => ({
    fontSize: '0.571rem',
    color: bedNoFont,
    width: '0.571rem',
    height: '0.5rem',
    position: 'absolute',
    transform: getCssValue(bedHead, 'rotate(0deg)', 'rotate(180deg)'),
  }),
}));

export default function VerticalBed({ showHead, style, isLinked, styles, editFloorPlan, displayBedNo, displayWardNo }) {
  const classes = useStyles(style ?? styles);

  return (
    <div className={classes.root}>
      <div className={classes.box1} />
      <div className={classes.box2}>{showHead && <BsGenderIcon className={classes.genderIcon} />}</div>
      <div className={classNames(classes.bedNo, classes.bedNoFont)}>
        {displayBedNo}
        {displayWardNo && <div className={classes.ward}>{displayWardNo}</div>}
      </div>
      {isLinked && editFloorPlan && <BsLinkIcon className={classes.linkIcon} />}
    </div>
  );
}
